module.exports = __webpack_public_path__ + "img/produto-detalhe.e0da5f18.svg";